import {
  toWSDateString,
  WSButton,
  WSFlexBox,
  WSIcon,
  WSText
} from "@wingspanhq/fe-component-library";
import {
  getCurrentTaxPaymentQuarter,
  getDaysUntilInternalDeadline
} from "@wingspanhq/utils/dist/date/taxDeadlines";
import { wsMoment } from "@wingspanhq/utils/dist/date/wsMoment";
import React, { useMemo } from "react";
import { ADD_TO_CALENDAR_LINK } from "../../../shared/utils/taxes";
import { openInNewTab } from "../../../utils/openInNewTab";
import { useModalQuarterInfo } from "../modals/ModalQuarterInfo";

export const NextPaymentInfo: React.FC = () => {
  const modalTaxInfo = useModalQuarterInfo();

  const text = useMemo(() => {
    const quarterInfo = getCurrentTaxPaymentQuarter();
    const daysUntil = getDaysUntilInternalDeadline(
      quarterInfo.internalDeadline
    );
    const internalDeadlineFromNow = wsMoment(
      quarterInfo.internalDeadline
    ).fromNow(true);

    const isFuture = daysUntil > 0;
    const isToday = daysUntil === 0;

    const diff = isFuture
      ? ` due in ${internalDeadlineFromNow} `
      : isToday
        ? " today "
        : ` was due ${internalDeadlineFromNow} ago`;

    return `Next quarterly payment${diff} (${toWSDateString(
      quarterInfo.internalDeadline,
      "monthDate"
    )}).`;
  }, []);

  return (
    <WSFlexBox.CenterY gap="S">
      <WSText.ParagraphXs>{text}</WSText.ParagraphXs>

      <WSIcon
        name="info-circle-fill"
        size="S"
        color="gray500"
        onClick={() => modalTaxInfo.open()}
      />

      <WSButton.Link
        size="S"
        onClick={() => {
          openInNewTab(ADD_TO_CALENDAR_LINK);
        }}
      >
        Subscribe to Tax Calendar
      </WSButton.Link>
    </WSFlexBox.CenterY>
  );
};
